// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"25cbe3835243822a","4744":"84adbd3bc4287d43"}[chunkId] + ".css";
};